<template>
  <transition name="el-fade-in-linear">
  <div v-if="show" class="wx-loading">
    <p>{{content}}</p>
  </div>
  </transition>
</template>

<script>
  export default {
    name: "wx-loading",
    props:{
      show:{
        type:Boolean,

      },
      content:{
        default:'正在加载',
        type:String,

      },
      type:{
        type:String,

      }

      }
    ,
    data(){
      return{

      }
    }
  }
</script>

<style scoped>
  .wx-loading{
    background: rgba(0,0,0,.5);
    color: white;
    text-align: center;
    width: 200px;
    padding: 20px;
    border-radius: 5px;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
  }

</style>



// WEBPACK FOOTER //
// wxLoading.vue?11e1c27e